export default "__VITE_ASSET__DmMZtbhX__"